import api from './api';

const userService = {
    /**
     * Get all admins with pagination and search
     */
    getUsers: async (params) => {
        try {
            const response = await api.get('/user', { params });
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    /**
     * Get a single admin by ID
     */
    getUserById: async (id) => {
        try {
            const response = await api.get(`/user/${id}`);
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    /**
     * Create a new admin
     */
    createUser: async (data) => {
        try {
            const response = await api.post('/user', data);
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    /**
     * Update an admin
     */
    updateUser: async (id, data) => {
        try {
            const response = await api.put(`/user/${id}`, data);
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    /**
     * Delete an admin
     */
    deleteUser: async (id) => {
        try {
            const response = await api.delete(`/user/${id}`);
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    }
};

export default userService;
